import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { memo } from "react";
import Tippy from "@tippyjs/react";
import * as styles from "./styles";
const Tooltip = ({ content, maxWidth = 260, padding = "small", skin = "dark", children, ...rest }) => {
    return (_jsx(Tippy, { maxWidth: `${maxWidth}px`, css: [styles.container(padding), styles.bySkin(skin)], content: content, ...rest, children: children }));
};
export default memo(Tooltip);
